/* Windows 95 Desktop Functionality */

class Windows95Desktop {
  constructor() {
    this.selectedIcon = null;
    this.clickTimer = null;
    this.clickDelay = 300; // milliseconds for double-click detection
    this.init();
  }

  init() {
    this.setupTaskbar();
    this.setupIconInteractions();
    this.updateClock();
    setInterval(() => this.updateClock(), 1000);
  }

  setupTaskbar() {
    // Add taskbar to page if it doesn't exist
    if (!document.querySelector('.win95-taskbar')) {
      const taskbar = document.createElement('div');
      taskbar.className = 'win95-taskbar';
      taskbar.innerHTML = `
        <button class="win95-start-button">Start</button>
        <div class="win95-taskbar-divider"></div>
        <div class="win95-taskbar-time"></div>
      `;
      document.body.appendChild(taskbar);
    }

    // Setup start button
    const startButton = document.querySelector('.win95-start-button');
    const startMenu = document.querySelector('#win95-start-menu');
    
    if (startButton && startMenu) {
      startButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Toggle menu visibility
        const isVisible = startMenu.style.display !== 'none';
        startMenu.style.display = isVisible ? 'none' : 'flex';
      });
      
      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        if (startMenu && startMenu.style.display === 'flex') {
          if (!startMenu.contains(e.target) && !startButton.contains(e.target)) {
            startMenu.style.display = 'none';
          }
        }
      });
      
      // Close menu when clicking a menu item
      const menuItems = startMenu.querySelectorAll('.win95-start-menu-item');
      menuItems.forEach(item => {
        item.addEventListener('click', () => {
          startMenu.style.display = 'none';
        });
      });
    }
  }

  updateClock() {
    const timeElement = document.querySelector('.win95-taskbar-time');
    if (timeElement) {
      const now = new Date();
      const timeString = now.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
      timeElement.textContent = timeString;
    }
  }

  setupIconInteractions() {
    const icons = document.querySelectorAll('.win95-icon');
    
    icons.forEach(icon => {
      // Single click to select
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (this.clickTimer === null) {
          // First click - select the icon
          this.selectIcon(icon);
          
          // Set timer for double-click detection
          this.clickTimer = setTimeout(() => {
            this.clickTimer = null;
          }, this.clickDelay);
        } else {
          // Second click within delay - it's a double-click
          clearTimeout(this.clickTimer);
          this.clickTimer = null;
          this.openProduct(icon);
        }
      });

      // Double-click as fallback
      icon.addEventListener('dblclick', (e) => {
        e.preventDefault();
        this.openProduct(icon);
      });

      // Keyboard support
      icon.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openProduct(icon);
        }
      });

      // Make icons focusable
      icon.setAttribute('tabindex', '0');
    });

    // Click outside to deselect
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.win95-icon')) {
        this.deselectAllIcons();
      }
    });
  }

  selectIcon(icon) {
    this.deselectAllIcons();
    icon.classList.add('selected');
    this.selectedIcon = icon;
  }

  deselectAllIcons() {
    document.querySelectorAll('.win95-icon').forEach(icon => {
      icon.classList.remove('selected');
    });
    this.selectedIcon = null;
  }

  openProduct(icon) {
    const productId = icon.dataset.productId;
    const productHandle = icon.dataset.productHandle;
    
    if (productId) {
      // Trigger custom event to open product popup
      const event = new CustomEvent('win95-open-product', {
        detail: { productId, productHandle }
      });
      document.dispatchEvent(event);
    }
  }

  // Utility function to center window on screen
  static centerWindow(windowElement) {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const windowWidth = windowElement.offsetWidth;
    const windowHeight = windowElement.offsetHeight;

    const left = Math.max(0, (viewportWidth - windowWidth) / 2);
    const top = Math.max(0, (viewportHeight - windowHeight) / 2);

    windowElement.style.left = `${left}px`;
    windowElement.style.top = `${top}px`;
  }

  // Utility function to bring window to front
  static bringToFront(windowElement) {
    const allWindows = document.querySelectorAll('.win95-window');
    let maxZIndex = 1000;
    
    allWindows.forEach(win => {
      const zIndex = parseInt(window.getComputedStyle(win).zIndex) || 1000;
      if (zIndex > maxZIndex) {
        maxZIndex = zIndex;
      }
    });

    windowElement.style.zIndex = maxZIndex + 1;
  }

  // Make window draggable
  static makeDraggable(windowElement) {
    const titleBar = windowElement.querySelector('.win95-title-bar');
    if (!titleBar) return;

    let isDragging = false;
    let currentX;
    let currentY;
    let initialX;
    let initialY;

    titleBar.addEventListener('mousedown', dragStart);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', dragEnd);

    function dragStart(e) {
      if (e.target.closest('.win95-window-controls')) return;
      
      Windows95Desktop.bringToFront(windowElement);
      
      initialX = e.clientX - windowElement.offsetLeft;
      initialY = e.clientY - windowElement.offsetTop;

      isDragging = true;
      windowElement.style.cursor = 'move';
    }

    function drag(e) {
      if (isDragging) {
        e.preventDefault();
        
        currentX = e.clientX - initialX;
        currentY = e.clientY - initialY;

        // Keep window on screen
        currentX = Math.max(0, Math.min(currentX, window.innerWidth - 100));
        currentY = Math.max(0, Math.min(currentY, window.innerHeight - 100));

        windowElement.style.left = currentX + 'px';
        windowElement.style.top = currentY + 'px';
      }
    }

    function dragEnd() {
      isDragging = false;
      windowElement.style.cursor = 'default';
    }

    // Touch support for mobile
    titleBar.addEventListener('touchstart', (e) => {
      if (e.target.closest('.win95-window-controls')) return;
      
      Windows95Desktop.bringToFront(windowElement);
      
      const touch = e.touches[0];
      initialX = touch.clientX - windowElement.offsetLeft;
      initialY = touch.clientY - windowElement.offsetTop;
      isDragging = true;
    });

    document.addEventListener('touchmove', (e) => {
      if (isDragging) {
        e.preventDefault();
        const touch = e.touches[0];
        
        currentX = touch.clientX - initialX;
        currentY = touch.clientY - initialY;

        currentX = Math.max(0, Math.min(currentX, window.innerWidth - 100));
        currentY = Math.max(0, Math.min(currentY, window.innerHeight - 100));

        windowElement.style.left = currentX + 'px';
        windowElement.style.top = currentY + 'px';
      }
    });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Windows95Desktop();
  });
} else {
  new Windows95Desktop();
}

// Export for use in other scripts
window.Windows95Desktop = Windows95Desktop;
